import all from '@mailobj-browser/front/js/selectors/all.js'
import defaults from '@mailobj-browser/front/js/selectors/defaults.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import append from '@mailobj-browser/front/js/tree/append.js'
import remove from '@mailobj-browser/front/js/tree/remove.js'
import globals from '#utilities/js/ea/globals.js'
import href from '#utilities/js/ea/href.js'
import * as utilities from '#utilities/js/styles.js'
import { elements } from '../../styles.js'
import * as sharedClasses from '#utilities/js/ea/sharedClasses.js'
import * as screenLocker from '#utilities/js/screen/lock.js'

export const ctrlButton = (name, target = defaults.document) => {
  return one(`.ea_chat__meet_controls [data-contract~="contracts.chat.mains.meet.controls.${name}"]`,
    target)
}

export const display = (elementAttribute) => {
  const element = one(elementAttribute)

  if (element !== null) {
    const parent = element.closest('#id_meet_container')

    for (const meet of all('[data-meet]', parent)) {
      if (!meet.classList.contains(utilities.modifiers.display.none)) {
        meet.classList.add(utilities.modifiers.display.none)
      }
    }

    element.classList.remove(utilities.modifiers.display.none)
  }
}

export const displayVideos = () => {
  display('[data-meet="meet_connect"]')
}

export const meetBlock = () => {
  return one(`.${elements.meet_connect}`)
}

export const divmeetOpen = async (id, params) => {
  const div_id = `div_meet_${id}`
  const { document } = defaults
  const { body } = document
  if (document.getElementById(div_id))
    return

  params = params ?? {}
  const join = params.join ?? 0
  const is_caller = params.is_caller ?? false

  let div_meet = one(`.${elements.meet}`)
  if (!div_meet) {
    div_meet = document.createElement('DIV')
    div_meet.classList.add(elements.meet)
  }
  div_meet.id = div_id

  if (!is_caller) {
    /* waiting for end of AJAX request to fill the div */
    div_meet.classList.add(utilities.modifiers.visibility.hidden)
    append(body, div_meet)
  } /* else : the caller sees the template */

  /* AJAX request */
  globals.ea_link_direct(
    href('chat/meet', { id, join }),
    div_id,
    (function (doIt, div) {
      return () => {
        if (doIt) {
          /* AJAX request completed : div is filled, we show it */
          div.classList.remove(utilities.modifiers.visibility.hidden)
        }
      }
    })(!is_caller, div_meet)
  )
  try {
    await screenLocker.lock()
  } catch (e) {
    console.error(e)
  }
  sharedClasses.add(div_meet, utilities.modifiers.overflow.hidden)
}

export const divmeetClose = async () => {
  const div = one('.' + elements.meet)

  await screenLocker.unlock()
  sharedClasses.remove(div, utilities.modifiers.overflow.hidden)
  remove(div)
}

globals.ea_meet_div = divmeetOpen
globals.ea_meet_displayvideos = displayVideos

